import { formatKoreanAddress } from "components/Form/KoreanAddressInput";
import { Column } from "components/Table/Simple";
import { formatDateTime } from "components/Table/Simple/presets";

export const columns: Column[] = [
    {
        field: "id",
        label: "고유번호",
    },
    {
        field: "created_at",
        label: "신청일",
        render: formatDateTime
    },
    {
        field: "updated_at",
        label: "수정일",
        render: formatDateTime
    },
    {
        field: "clinicName",
        label: "병원명",
    },
    {
        field: "address",
        label: "주소",
        render: (value, field, row) => {
            return formatKoreanAddress(row.address);
        }
    },
    {
        field: "submitter",
        label: "신청자",
    },
    {
        field: "email",
        label: "이메일",
    },
    {
        field: "phone",
        label: "전화번호",
    },
    {
        field: "affiliation",
        label: "소속",
    },
    {
        field: "position",
        label: "직위",
    },
    {
        field: "source",
        label: "신청경로",
        render: (value, field, row) => {
            return row?.otherInfos?.source.join(", ");
        }
    },
    {
        field: "service",
        label: "사용중인 서비스",
        render: (value, field, row) => {
            return row?.otherInfos?.service.join(", ");
        }
    },
    {
        field: "otherInfos",
        label: "기타 정보",
        visible: false,
    }
]